export var RsvpStatus;
(function (RsvpStatus) {
    RsvpStatus[RsvpStatus["YES"] = 0] = "YES";
    RsvpStatus[RsvpStatus["NO"] = 1] = "NO";
    RsvpStatus[RsvpStatus["WAITING"] = 2] = "WAITING";
})(RsvpStatus || (RsvpStatus = {}));
